import {Component, OnInit, HostListener, Output, EventEmitter, Input} from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import {AdminService} from '../../../shared/admin.services';
import {UrlConstants} from '../../../shared/url.constant';
import {CommonUtil} from '../../../utils/common.util';
import { Router } from '@angular/router';

@Component({
  selector: 'history-search',
  templateUrl: './history-search.component.html',
  styleUrls: ['./history-search.component.scss']
})
export class HistorySearchComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();
  public DATE_CONFIG = CommonUtil.DATE_CONFIG;
  public START_YEAR = CommonUtil.getStartAcademicYear();
  public END_YEAR = CommonUtil.getEndAcademicYear();

  public displayMessage;

  public discountList = [];
  public bankList = [];
  public fixedFeeList = [];
  public specialFeeList = [];
  public classList = [];
  public academicList = [];
  sectionList = [];

  public searchForm;

  public showloader = false;

  YTD;
  MTD;
  WEEK_AGO;
  DAY_AGO;
  @Input() currentMenu
  constructor(public fb: FormBuilder, private adminService: AdminService, private router: Router) {
      this.loadDiscountList();
      this.loadBankList();
      this.loadSpecialFeeList();
      this.loadFixedFeeList();
      this.loadClass();
      this.loadAcademicList();

      this.initSearch();
   }

   initSearch() {

     this.quickSearchDates();

     this.searchForm = this.fb.group({
       quickSearch: [this.DAY_AGO],
       date_range: [this.getSpecificDateAndTime(new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000))) +  ' - ' + this.getCurrentDateAndTime()],
       student_ref: [''],
       student_ref_type: [''],
       class_id: [''],
       section_id: [''],
       payment_status: [''],
       discount_id: [''],
       bank_id: [''],
       payment_mode: [''],
       academic_fee_id: [''],
       fixed_fee_id: [''],
       special_fee_id: ['']
     });

     this.onSearch();

   }

   quickSearchDates() {
     this.YTD = this.getSpecificDateAndTime(new Date().getFullYear() + '-' + 1 + '-' + 1) +  ' - ' + this.getCurrentDateAndTime();
    //  this.YTD = this.getSpecificDateAndTime(this.START_YEAR) +  ' - ' + this.getCurrentDateAndTime();
     console.log('### YTD ###', this.YTD);

     const CURRENT_MONTH = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + 1;
     // console.log('Current Month ', CURRENT_MONTH);
     this.MTD = this.getSpecificDateAndTime(CURRENT_MONTH) +  ' - ' + this.getCurrentDateAndTime();
     console.log('### MTD ###', this.MTD);

     const first = new Date().getDate() - new Date().getDay(); // First day is the day of the month - the day of the week
     const CURRENT_WEEK = new Date(new Date().setDate(first)).toUTCString();
     // console.log('Current week ', CURRENT_WEEK);
     const WEEK_AGO = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
     // console.log('Week ago', WEEK_AGO);
     this.WEEK_AGO = this.getSpecificDateAndTime(WEEK_AGO) +  ' - ' + this.getCurrentDateAndTime();
     console.log('### WEEK AGO ###', this.WEEK_AGO);

     const DAY_AGO = new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
     // console.log('Day ago', DAY_AGO);
     this.DAY_AGO = this.getSpecificDateAndTime(DAY_AGO) +  ' - ' + this.getCurrentDateAndTime();
     console.log('### DAY AGO ###', this.DAY_AGO);
   }

  onChangeQuickSearch(value) {
    this.searchForm.controls.date_range.setValue(value);
  }

  dateRangeChange() {
    // this.searchForm.controls.quickSearch.setValue('');
  }

   async loadDiscountList() {
    const loadDiscountData = await this.adminService.loadDiscount({ url: UrlConstants.discounts, params: '' });
      this.discountList = loadDiscountData.data;
  }

  async loadBankList() {
    const loadBankData = await this.adminService.get({ url: UrlConstants.bankInfo, params: '' });
      this.bankList = loadBankData.data;
  }

  async loadSpecialFeeList() {
    const loadFixedFeeData = await this.adminService.get({ url: UrlConstants.fixedFeeInfo, params: '' });
      this.fixedFeeList = loadFixedFeeData.data;
  }

  async loadFixedFeeList() {
    const loadspecialFeeListData = await this.adminService.get({ url: UrlConstants.SpecialFee, params: '' });
      this.specialFeeList = loadspecialFeeListData.data;
  }

  async loadClass() {
    const loadclassData = await this.adminService.get({ url: UrlConstants.classes, params: '' });
      this.classList = loadclassData.data;
  }

  onClassChange(classId) {
    console.log(classId, 'classId');
    this.loadSection(classId);
  }

  async loadSection(classId) {
      const sectionData = await this.classList.filter(item => item.class_id === classId);
      this.sectionList = sectionData[0].sections;
  }

  async loadAcademicList() {
    const loadloadAcademicListData = await this.adminService.get({ url: UrlConstants.getAllAcademicFee, params: '' });
      this.academicList = loadloadAcademicListData.data;
  }

  getSpecificDateAndTime(date) {
    const specificDate = new Date(date);
    const datetime = specificDate.getFullYear() + '-'
      + (specificDate.getMonth() + 1)  + '-'
      + (specificDate.getDate()) + ' '
      + specificDate.getHours() + ':'
      + specificDate.getMinutes() + ':'
      + specificDate.getSeconds();

    // console.log('Specific date & time ## ', 'YYYY-MM-DD HH:MM:SS');
    // console.log('Specific date & time ## ', datetime);
    return datetime;
  }

  getCurrentDateAndTime() {
    const currentdate = new Date();
    const datetime = currentdate.getFullYear() + '-'
      + (currentdate.getMonth() + 1)  + '-'
      + (currentdate.getDate()) + ' '
      + currentdate.getHours() + ':'
      + currentdate.getMinutes() + ':'
      + currentdate.getSeconds();

    // console.log('Current date & time ## ', 'YYYY-MM-DD HH:MM:SS');
    // console.log('Current date & time ## ', datetime);
    return datetime;
  }

  @Output() onSearchClicked: EventEmitter<any> = new EventEmitter<any>();

  onSearch() {
    let success = true;
    if (this.searchForm.controls.student_ref_type.value || this.searchForm['controls'].student_ref.value) {
      if (!this.searchForm.controls.student_ref_type.value && this.searchForm['controls'].student_ref.value ) {
        this.displayMessage = 'Select student reference type and proceed';
        success = false
        // return;
      } else if (this.searchForm.controls.student_ref_type.value && !this.searchForm['controls'].student_ref.value) {
        this.displayMessage = 'Enter student reference and proceed';
        success = false

        // return;
      } else {
        this.displayMessage = '';
        success = true

      }
    } else {
      this.displayMessage = '';
      success = true

    }

    console.log(' ## ' + this.checkStringWithHyphen(this.searchForm.controls.date_range.value) + ' ## ' + this.searchForm.controls.date_range.value)

    let dateArr = [];
    if (this.checkStringWithHyphen(this.searchForm.controls.date_range.value)) {
      dateArr = this.searchForm.controls.date_range.value.split(' - ');
    } else {
     dateArr = this.searchForm.controls.date_range.value;
    }

    const from_date = this.getSpecificDateAndTime(dateArr[0]);
    const to_date = this.getSpecificDateAndTime(dateArr[1]);

    console.log(' ## FROM ' + from_date + ' ## TO ' + to_date);

    const student_ref = this.searchForm.controls.student_ref.value ? this.searchForm.controls.student_ref.value : null;
    const student_ref_type = this.searchForm.controls.student_ref_type.value ? this.searchForm.controls.student_ref_type.value : null;
    const class_id = this.searchForm.controls.class_id.value ? this.searchForm.controls.class_id.value : null;
    const section_id = this.searchForm.controls.section_id.value ? this.searchForm.controls.section_id.value : null;
    const payment_status = this.searchForm.controls.payment_status.value ? this.searchForm.controls.payment_status.value : 'all';
    const discount_id = this.searchForm.controls.discount_id.value ? this.searchForm.controls.discount_id.value : 'all';
    const bank_id = this.searchForm.controls.bank_id.value ? this.searchForm.controls.bank_id.value : 'all';
    const academic_fee_id = this.searchForm.controls.academic_fee_id.value ? this.searchForm.controls.academic_fee_id.value : 'all';
    const fixed_fee_id = this.searchForm.controls.fixed_fee_id.value ? this.searchForm.controls.fixed_fee_id.value : 'all';
    const special_fee_id = this.searchForm.controls.special_fee_id.value ? this.searchForm.controls.special_fee_id.value : 'all';
    const payment_mode = this.searchForm.controls.payment_mode.value ? this.searchForm.controls.payment_mode.value : 'all';
    const limit = 20;
    let params = '';

    params =
      'from=' + from_date +
      '&to=' + to_date +
      '&student_ref=' + student_ref +
      '&student_ref_type=' + student_ref_type +
      '&class_id=' + class_id +
      '&section_id=' + section_id +
      '&payment_status=' + payment_status +
      '&discount_id=' + discount_id +
      '&bank_id=' + bank_id +
      '&academic_fee_id=' + academic_fee_id +
      '&fixed_fee_id=' + fixed_fee_id +
      '&special_fee_id=' + special_fee_id +
      '&payment_mode=' + payment_mode +
      '&limit=' + limit;

    const data = {
      queryParams : params,
      displayMessage : this.displayMessage,
      success: success,
      cancelMessage: '',
      cancelSuccess: false

    };
    console.log('data #### ', data);

    setTimeout(() => { this.onSearchClicked.emit(data); }, 100);

  }

  onReset() {
    this.initSearch();
  }

  checkStringWithHyphen(dateString) {
    return !!(dateString).toString().match(/-/);
  }

  ngOnInit() {
        // advanced search
        (<any>$('.link-more-fields span').click(function() {
          $(this).text($(this).text() === 'Show Advance Search' ? 'Hide Advance Search' : 'Show Advance Search');
        }));

        // icon btn tooltip
        (<any>$(function () {
          (<any>$('[data-toggle="tooltip"]')).tooltip();
        }));
  }

}
